/**
 * The Prism (Task 220 POC) — fetch the compiled layer annotations.
 * Absent/empty artifact → index null; every surface renders exactly as today.
 *
 * `settled` (Task 223) flips true once the fetch RESOLVED either way — the
 * reader's scroll effects wait for it, because prism chips/filter shift layout
 * when they arrive and a scroll performed before that drifts.
 */
import { useEffect, useState } from "react";
import { buildPrismIndex, type PrismArtifact, type PrismIndex } from "./prism";

export interface PrismLoad {
  index: PrismIndex | null;
  settled: boolean;
}

export function usePrismData(): PrismLoad {
  const [state, setState] = useState<PrismLoad>({ index: null, settled: false });
  useEffect(() => {
    let alive = true;
    fetch("/prism-data/layers.json", { headers: { Accept: "application/json" }, cache: "no-cache" })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((data: PrismArtifact) => {
        if (!alive) return;
        const ok = data && Array.isArray(data.sections) && data.sections.length > 0;
        setState({ index: ok ? buildPrismIndex(data) : null, settled: true });
      })
      .catch(() => alive && setState({ index: null, settled: true }));
    return () => {
      alive = false;
    };
  }, []);
  return state;
}
